import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { action } from 'satcheljs';

export interface RecipientData {
    isValid: boolean;
    newPersona: FindRecipientPersonaType;
    newEmailAddress?: string;
}

const addReadWriteRecipients = action(
    'addReadWriteRecipients',
    (
        recipientWell: RecipientWellWithFindControlViewState,
        recipientData: RecipientData[],
        resetFindResult: boolean = true
    ) => ({
        recipientWell,
        recipientData,
        resetFindResult,
    })
);

export default addReadWriteRecipients;
